import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import {
  SeButtonModule,
} from '@se-ui-components';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SeButtonModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
